/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}.remember-and-login-row[_ngcontent-%COMP%]{display:flex}.remember-me-checkbox[_ngcontent-%COMP%]{flex:1 1 auto;padding-top:8px}.login-button[_ngcontent-%COMP%]{flex:1 1 auto;text-align:right}.info-row[_ngcontent-%COMP%]{margin:35px 0;text-align:center}.color-secondary[_ngcontent-%COMP%]{margin-right:5px}.social-icons[_ngcontent-%COMP%]{text-align:center}"];
export { styles as styles };
